"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable react/no-danger */
var EmptyResultView = function EmptyResultView(_ref) {
  var errorMessage = _ref.errorMessage;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "resources outer-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "inner-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "empty-error outer-container",
    dangerouslySetInnerHTML: {
      __html: errorMessage
    }
  })));
};

EmptyResultView.propTypes = {
  errorMessage: _propTypes["default"].string.isRequired
};
var _default = EmptyResultView;
exports["default"] = _default;